import {
  ChecklistMetadataLookup,
  ChecklistMetadataLookupArgs,
  getChecklistMetadataLookup,
} from '../assets/ts/data/checklist-metadata-lookup'
import useServerData from './use-server-data'

function useChecklistsMetadataLookup(
  fetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: checklistsMetadataLookup,
    error: checklistsMetadataLookupError,
    fetchData: fetchChecklistsMetadataLookup,
    isLoading: checklistsMetadataLookupIsLoading,
  } = useServerData<ChecklistMetadataLookup, ChecklistMetadataLookupArgs>(
    getChecklistMetadataLookup,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    checklistsMetadataLookup,
    checklistsMetadataLookupError,
    checklistsMetadataLookupIsLoading,
    fetchChecklistsMetadataLookup,
  }
}

export default useChecklistsMetadataLookup
